import { render, staticRenderFns } from "./ShiPin.vue?vue&type=template&id=78476f16&scoped=true&"
import script from "./ShiPin.vue?vue&type=script&lang=js&"
export * from "./ShiPin.vue?vue&type=script&lang=js&"
import style0 from "./ShiPin.vue?vue&type=style&index=0&id=78476f16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78476f16",
  null
  
)

export default component.exports